<template>
  <div class="flex-col item-height">
    <div class="flex-row page-top"
      v-show="false">
      {{ $t("search.searchTitle") }}
    </div>
    <van-tabs v-model="active"
      @click="tabClick"
      class="tabs-list">
      <van-tab class="tab-info"
        :title='$t("common.orgnazation")'>
        <div class="search-info">
          <span class="iconfont iconleft-chevron-fill left-icon"
            @click="goBack"
            v-if="orgSearch.isList"></span>
          <form action=""
            onsubmit="return false;"
            class="form-info">
            <div class="flex-row">
              <input class="input-style"
                type="text"
                v-model="orgSearch.search"
                autocomplete="off"
                @blur="onBlur('org')"
                @keypress.enter.stop="onSubmit($event,'org')"
                @keyup="getMyDeBounce($event,'org')"
                @focus="getMyDeBounce($event,'org')"
                placeholder="请输入搜索关键词">
              <van-icon v-show="orgSearch.search != ''"
                @click="orgSearch.search = '';onSubmit($event,'org')"
                class="search-clear"
                name="clear" />
              <van-button class="search-button"
                @click="onSubmit($event,'org')"
                native-type="button">搜索</van-button>
            </div>
            <select-panel v-show="orgSearch.show"
              style="margin-top: 10px;min-width:90%;max-width:90%;"
              :component-name="orgSearch.search"
              :loading="orgSearch.loading"
              :data-list="orgSearch.options"
              @itemClick="selectOrgChanged"></select-panel>
          </form>
        </div>

        <div v-show="showOrgSearchPanel"
          class="search-panel">
          <div class="split-info" />
          <search-history-bar :search-type='orgType'
            :top-num='historyNum'
            ref='orgHistorybar'
            @historyClick="searchByHistory">
          </search-history-bar>
          <div class="split-info" />
          <search-type-item :search-type="orgStage"
            @typeClick="searchByType"></search-type-item>
          <div class="split-info" />
          <search-type-item :search-type="orgIndustry"
            @typeClick="searchByType"></search-type-item>
        </div>
        <div v-show="!showOrgSearchPanel"
          class="org-panel">
          <org-list ref='orgList'
            id="org-list"></org-list>
        </div>
      </van-tab>
      <van-tab class="tab-info"
        :title='$t("investdCompany")'
        title-style="flex:1.2 1 30%">
        <div class="search-info">
          <span class="iconfont iconleft-chevron-fill left-icon"
            v-if="companySearch.isList"
            @click="goBack"></span>
          <form action=""
            onsubmit="return false;"
            class="form-info">
            <div class="flex-row">
              <input class="input-style"
                type="text"
                v-model="companySearch.search"
                autocomplete="off"
                @blur="onBlur('company')"
                @keypress.enter.stop="onSubmit($event,'company')"
                @keyup="getMyDeBounce($event,'company')"
                @focus="getMyDeBounce($event,'company')"
                placeholder="请输入搜索关键词">
              <van-icon v-show="companySearch.search != ''"
                @click="companySearch.search = '';onSubmit($event,'company')"
                class="search-clear"
                name="clear" />
              <van-button class="search-button"
                @click="onSubmit($event,'company')"
                native-type="button">搜索</van-button>
            </div>
            <select-panel v-show="companySearch.show"
              style="margin-top: 10px;min-width:90%;max-width:90%;"
              :component-name="companySearch.search"
              :loading="companySearch.loading"
              :data-list="companySearch.options"
              @itemClick="selectCompanyChanged"></select-panel>
          </form>
        </div>
        <div v-show="showCompanySearchPanel"
          class="search-panel">
          <div class="split-info" />
          <search-history-bar :search-type='companyType'
            :top-num='historyNum'
            @historyClick="searchByHistory"
            ref='companyHistorybar'>
          </search-history-bar>
          <div class="split-info" />
          <search-type-item :search-type="companyIndustry"
            @typeClick="searchByType"></search-type-item>
          <div class="split-info" />
          <search-type-item :search-type="companyRound"
            @typeClick="searchByType"></search-type-item>
          <div class="split-info" />
          <search-type-item :search-type="companyInvestmentDate"
            @typeClick="searchByType"></search-type-item>
        </div>
        <div v-show="!showCompanySearchPanel"
          class="org-panel">
          <invested-list ref='companyList'
            id='company-list'></invested-list>
        </div>
      </van-tab>
      <van-tab class="tab-info"
        :title='$t("search.pwcContact")'
        title-style="flex:1.5">
        <div class="search-info">

          <span class="iconfont iconleft-chevron-fill left-icon"
            v-if="relationSearch.isList"
            @click="goBack"></span>
          <form action=""
            onsubmit="return false;"
            class="form-info">
            <div class="flex-row">
              <input class="input-style"
                type="text"
                v-model="relationSearch.search"
                autocomplete="off"
                @blur="onBlur('relation')"
                @keypress.enter.stop="onSubmit($event,'relation')"
                @keyup="getMyDeBounce($event,'relation')"
                @focus="getMyDeBounce($event,'relation')"
                placeholder="请输入搜索关键词">
              <van-icon v-show="relationSearch.search != ''"
                @click="relationSearch.search = '';onSubmit($event,'relation')"
                class="search-clear"
                name="clear" />
              <van-button class="search-button"
                @click="onSubmit($event,'relation')"
                native-type="button">搜索</van-button>
            </div>
            <select-panel v-show="relationSearch.show"
              style="margin-top: 10px;min-width:90%;max-width:90%;"
              :component-name="relationSearch.search"
              :loading="relationSearch.loading"
              :data-list="relationSearch.options"
              @itemClick="selectRelationChanged"></select-panel>
          </form>
        </div>
        <div class="search-panel">
          <div class="split-info"
            v-show="false" />
          <search-history-bar v-show="false"
            :search-type='relationshipType'
            :top-num='historyNum'
            @historyClick="searchByHistory"
            @del="delHis2"
            ref='contactHistorybar'></search-history-bar>
          <div class="split-info"
            v-show="false" />
          <search-relationship-list ref='searchRelationshipListByKeyword'
            @relationtabChange="realtionTabChange"
            id='relationship-list'></search-relationship-list>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import webService from "../../network/webService";
import OrgList from "../../components/content/org/OrgList.vue";
import userInfo from "../../common/loginInfo";
import SearchTypeItem from "../../components/common/SearchTypeItem.vue";
import commonjs from "../../common/common";
import InvestedList from "../../components/content/invested/InvestedList.vue";
import ContractorList from "../../components/content/contractor/ContractorList.vue";
import SearchHistoryBar from "../../components/common/SearchHistoryBar.vue";
import SearchRelationshipList from "./SearchRelationshipList.vue";
import SelectPanel from "../../components/common/SelectPanel";
import scollerLocation from '@/common/scollerLocation';
import storejs from "@common/store.js";
import eventHub from "@/common/EventHub";
import _ from "lodash";

var orgDe, companyDe, relationDe;
export default {
  name: "SearchHome",
  components: {
    OrgList,
    SearchTypeItem,
    InvestedList,
    ContractorList,
    SearchHistoryBar,
    SearchRelationshipList,
    SelectPanel,
  },
  data () {
    return {
      companyIndex: 1,
      relationActive: 0,
      active: 0,
      historyNum: 5,
      title: "title",
      relationDeepth: "relationDeepth",
      orgStage: "orgStage",
      orgIndustry: "orgIndustry",
      companyIndustry: "companyIndustry",
      companyRound: "companyRound",
      companyInvestmentDate: "companyInvestmentDate",
      showAllSearchPanel: true,
      showOrgSearchPanel: true,
      showCompanySearchPanel: true,
      showContactSearchPanel: true,
      searchModel: {
        Search: "",
      },
      orgType: commonjs.searchHistoryTypeEnum.Organization,
      companyType: commonjs.searchHistoryTypeEnum.Company,
      relationshipType: commonjs.searchHistoryTypeEnum.Relationship,

      orgSearch: {
        search: '',
        options: [],
        loading: false,
        isList: false,
        show: false,
      },
      companySearch: {
        search: '',
        options: [],
        loading: false,
        isList: false,
        show: false,
      },
      relationSearch: {
        search: '',
        options: [],
        loading: false,
        isList: false,
        show: false,
      },
    };
  },
  mounted () {
    setTimeout(() => {
      this.orgSearch.show = false;
      this.searchOrg();
    }, 500);
  },
  created () {
    orgDe = _.debounce(this.getMyOrgList, 200);
    companyDe = _.debounce(this.getCompanyList, 200);
    relationDe = _.debounce(this.getRelationList, 200);
  },
  activated () {
    scollerLocation.recoverLocation('org-list');
    scollerLocation.recoverLocation('company-list');
    scollerLocation.recoverLocation('relationship-list');
  },
  beforeRouteLeave (to, from, next) {
    var orgList = document.querySelector('#org-list .cont-list');
    if (orgList) {
      scollerLocation.saveLocation('org-list', orgList);
    }
    var companyList = document.querySelector('#company-list .cont-list');
    if (companyList) {
      scollerLocation.saveLocation('company-list', companyList);
    }
    var relationshipList = document.querySelector('#contractor-list #org-group');
    if (relationshipList) {
      scollerLocation.saveLocation('relationship-list', relationshipList);
    }
    var relationshipCompanyList = document.querySelector('#contractor-company-list #company-group');
    if (relationshipCompanyList) {
      scollerLocation.saveLocation('relationship-list', relationshipCompanyList);
    }
    next();
  },
  methods: {
    tabClick () {
      console.log('tab:' + this.active);
      if (this.active == 1 && this.companyIndex == 1) {
        setTimeout(() => {
          this.searchModel.isHistory = false;
          this.searchModel.hasFilter = false;
          this.companySearch.show = false;
          this.searchCompany();
          this.companyIndex = this.companyIndex + 1;
        }, 500);

      }
    },
    getMyDeBounce (ev, type) {
      if (type == "org") {
        orgDe(ev);
      }
      if (type == "company") {
        companyDe(ev);
      }
      if (type == "relation") {
        relationDe(ev);
      }
    },
    getMyOrgList (ev) {
      if (ev.keyCode == 38 || ev.keyCode == 40) {
        return false;
      }
      this.remoteOrgMethod(this.orgSearch.search);
    },
    //添加搜索历史
    addSearchHistory (value, searchType) {
      if (_.isEmpty(_.trim(value))) return;
      var addSearcheDto = {
        userId: userInfo.userToken.userId,
        content: value,
        type: searchType,
      };
      webService.addSearchHistory(addSearcheDto);
    },
    selectOrgChanged (item) {
      this.orgSearch.search = item.name;
      this.orgSearch.show = false;
      this.addSearchHistory(this.orgSearch.search, this.orgType);
      this.searchOrg();
    },
    remoteOrgMethod (query) {
      if (query !== '') {
        this.orgSearch.loading = true;
        this.orgSearch.options = [];
        webService.getOrganizationsByName(query).then((res) => {
          this.orgSearch.loading = false;
          this.orgSearch.options = res.data;
          this.orgSearch.show = this.orgSearch.options.length > 0;
        });
      } else {
        this.orgSearch.options = [];
        this.orgSearch.show = false;
      }
    },
    //机构搜索
    searchOrg (type, typeValue) {
      if (type) {
        this.searchModel.hasFilter = true;
        if (type == commonjs.commonInfoEnmus.OrgStage) {
          this.searchModel.OrgStage = typeValue;
        }
        if (type == commonjs.commonInfoEnmus.OrgIndustry) {
          this.searchModel.OrgIndustry = typeValue;
        }
      }
      this.searchModel.SearchType = 1;
      this.searchModel.Search = this.orgSearch.search;
      this.showOrgSearchPanel = false;
      this.orgSearch.isList = true;
      this.$nextTick(function () {
        this.$refs.orgList.getData(this.searchModel);
      });

    },
    onSubmit (ev, type) {
      //ev.srcElement.blur();
      setTimeout(() => {
        console.log('onSubmit')
        if (type == "org") {
          this.orgSearch.show = false;
          this.addSearchHistory(this.orgSearch.search, this.orgType);
          this.searchOrg();
        }
        if (type == "company") {
          this.companySearch.show = false;
          this.addSearchHistory(this.companySearch.search, this.companyType);
          this.searchCompany();
        }
        if (type == "relation") {
          this.relationSearch.show = false;
          this.addSearchHistory(this.relationSearch.search, this.relationshipType);
          this.searchContact();
        }
      }, 1000);

    },
    //公司搜索 
    getCompanyList (ev) {
      if (ev.keyCode == 38 || ev.keyCode == 40) {
        return false;
      }
      setTimeout(() => {
        this.remoteCompanyMethod(this.companySearch.search);
      });
    },
    selectCompanyChanged (search) {
      this.companySearch.search = search.name;
      this.companySearch.show = false;
      this.addSearchHistory(this.companySearch.search, this.companyType);
      this.searchCompany();
    },
    remoteCompanyMethod (query) {
      if (query !== '') {
        this.companySearch.loading = true;
        this.companySearch.options = [];
        webService.getCompanysByName(query).then((res) => {
          this.companySearch.loading = false;
          this.companySearch.options = res.data;
          this.companySearch.show = this.companySearch.options.length > 0;
        });
      } else {
        this.companySearch.options = [];
        this.companySearch.show = false;
      }
    },
    //被投公司
    searchCompany (type, typeValue) {
      if (type) {
        this.searchModel.hasFilter = true;
        if (type == commonjs.commonInfoEnmus.Country) {
          this.searchModel.CountryIds = typeValue;
        }
        if (type == commonjs.commonInfoEnmus.CompanyRound) {
          this.searchModel.InvestmentRoundIds = typeValue;
        }
        if (type == commonjs.commonInfoEnmus.CompanyInvestmentDate) {
          this.searchModel.InvestmentDate = typeValue;
        }
        if (type == commonjs.commonInfoEnmus.CompanyIndustry) {
          this.searchModel.IndustryNames = typeValue;
        }
      }
      this.searchModel.SearchType =
        commonjs.relationshipSearchTypeEnum.Invested;
      this.searchModel.Search = this.companySearch.search;

      this.$refs.companyList.getData(this.searchModel);
      this.showCompanySearchPanel = false;
      this.companySearch.isList = true;
    },
    //关系搜索 
    getRelationList (ev) {
      if (ev.keyCode == 38 || ev.keyCode == 40) {
        return false;
      }
      setTimeout(() => {
        this.remoteRelationMethod(this.relationSearch.search);
      });
    },
    remoteRelationMethod (query) {
      if (query !== '') {
        this.relationSearch.loading = true;
        this.relationSearch.options = [];
        webService.searchRelationByName(this.relationActive, query).then((res) => {
          this.relationSearch.loading = false;
          this.relationSearch.options = res.data;
          this.relationSearch.show = this.relationSearch.options.length > 0;
        });
      } else {
        this.relationSearch.options = [];
        this.relationSearch.show = false;
      }
    },
    //pwc关系搜索
    selectRelationChanged (search) {
      this.relationSearch.search = search.name;
      this.relationSearch.show = false;
      this.addSearchHistory(this.relationSearch.search, this.relationshipType);
      this.searchContact();
    },
    realtionTabChange (tabIndex) {
      this.relationActive = tabIndex;
      this.addSearchHistory(this.relationSearch.search, this.relationshipType);
      this.$nextTick(function () {
        this.searchContact();
      });

    },
    //PWC认识搜索
    searchContact (type, typeValue) {
      if (type) {
        this.searchModel.hasFilter = true;
        if (type == commonjs.commonInfoEnmus.Responsibility) {
          this.searchModel.ResponsibilityIds = typeValue;
        }
        if (type == commonjs.commonInfoEnmus.Title) {
          this.searchModel.TitleIds = typeValue;
        }
        if (type == commonjs.commonInfoEnmus.RelationDeepth) {
          this.searchModel.RelationDeepthIds = typeValue;
        }
      }
      this.searchModel.SearchType = 2;
      this.searchModel.Search = this.relationSearch.search;

      this.showContactSearchPanel = false;
      this.$refs.searchRelationshipListByKeyword.getData(
        this.searchModel
      );
      this.relationSearch.isList = true;
    },
    delHis2 () {
      let h = this.$refs.contactHistorybar.$el.offsetHeight;
      console.log("h: ", h);
      this.$refs.searchRelationshipListByKeyword.changeH(h);
    },
    searchByHistory (historyValue) {
      this.initSearchModel();
      this.searchModel.isHistory = true;
      switch (this.active) {
        case 0:
          //把其他选中项还原
          storejs.state.orgStage = null;
          storejs.state.orgIndustry = null;
          this.orgSearch.search = historyValue;
          this.searchOrg();
          break;
        case 1:
          storejs.state.companyIndustry = null;
          storejs.state.companyRound = null;
          storejs.state.companyInvestmentDate = null;
          //eventHub.$emit('ClearPanel', 'company');
          this.companySearch.search = historyValue;
          this.searchCompany();
          break;
        case 2:
          this.relationSearch.search = historyValue;
          this.searchContact();
          break;
      }
    },
    searchByType (type, typeValue) {
      this.initSearchModel();
      this.searchModel.isHistory = true;
      switch (this.active) {
        case 0:
          this.searchOrg(type, typeValue);
          break;
        case 1:
          this.searchCompany(type, typeValue);
          break;
        case 2:
          this.searchContact(type, typeValue);
          break;
      }
    },
    goBack () {
      switch (this.active) {
        case 0:
          this.orgSearch.isList = false;
          this.showOrgSearchPanel = true;
          this.$refs.orgHistorybar.loadData();
          this.$refs.orgList.reset();
          break;
        case 1:
          this.companySearch.isList = false;
          this.showCompanySearchPanel = true;
          this.$refs.companyHistorybar.loadData();
          this.$refs.companyList.reset();
          break;
        case 2:
          this.relationSearch.isList = false;
          this.showContactSearchPanel = true;
          this.$refs.contactHistorybar.loadData();
          break;
      }
    },
    initSearchModel () {
      this.searchModel = {
        Search: "",
        isHistory: false,
      };
    },
    onBlur (type) {
      setTimeout(() => {
        //选择了机构后，用户需要重新选择
        if (type == "org") {
          this.orgSearch.show = false;
          this.$nextTick(function () {
            console.log(this.$refs.orgList)
            if (this.$refs.orgList) {
              this.$refs.orgList.changeSearchValue(this.orgSearch.search);
            }
          });
        }
        if (type == "company") {
          this.companySearch.show = false;
          this.$nextTick(function () {
            console.log(this.$refs.companyList)
            if (this.$refs.companyList) {
              this.$refs.companyList.changeSearchValue(this.companySearch.search);
            }
          });
        }
        if (type == "relation") {
          this.relationSearch.show = false;
          this.$nextTick(function () {
            console.log(this.$refs.searchRelationshipListByKeyword)
            if (this.$refs.searchRelationshipListByKeyword) {
              this.$refs.searchRelationshipListByKeyword.changeSearchValue(this.relationSearch.search);
            }
          });
        }
      }, 100);
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../styles/theme.scss";
.search-bar {
  padding: 1rem;
}
.page-top {
  height: 4.375rem;
  align-items: center;
  font-weight: bolder;
  font-size: 1.625rem;
  padding-left: 30px;
}
.search-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 20px;
}
.search-button {
  //height: 37px;
  background-color: #eeeeee;
  width: 25%;
}
.form-info {
  width: 100%;
  background-color: #eeeeee;
  font-size: 0.875rem;
}
.input-style {
  background-color: #eeeeee;
  border: none;
  width: 75%;
  //height: 35px;
}
.back-btn {
  width: 30px;
  height: 25px;
  background: #c52a1a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.left-icon {
  color: #c52a1a;
  font-weight: 700;
  font-size: 20px !important;
  padding-right: 5px;
}
.tabs-list {
  //height: calc(100% - 4.375rem);
  height: 100%;
}
/deep/ .van-icon {
  padding-right: 4px;
}
.tab-info {
  height: 100%;
}
/deep/ .iconfont {
  font-size: 14px;
}
/deep/ .van-tab {
  //font-size: 18px;
  font-size: 00.875rem;
}
/deep/ .van-tab--active {
  color: #c52a1a;
}
/deep/ .van-tabs__content {
  height: calc(100% - 50px);
}
.search-panel {
  height: calc(100% - 55px);
  //overflow: auto;
  padding-top: 4px;
  flex: 1;
}
/deep/ .van-tabs__line {
  background-color: #c52a1a;
}
/deep/ .van-tab__text {
  font-weight: bolder;
  font-size: 16px;
}
// /deep/ .van-tabs__nav--card {
//   border-color: #c52a1a !important;
// }
.org-panel {
  padding-left: 1rem;
  height: calc(100% - 50px);
  overflow: auto;
  flex: 1;
}
.split-info {
  height: 5px;
}
/deep/ .el-input__inner {
  height: 40px;
  width: 100%;
  background-color: #f2f2f2;
  border: none;
}
input::placeholder {
  padding-left: 10px;
}
.search-clear {
  margin: 0px 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #a7a7b4;
}
</style>



// WEBPACK FOOTER //
// src/views/search/SearchHome.vue